<template>
  <div class="row shadow-none">
    <div class="col">
      <div :class="['be-loading', { 'be-loading-active': isBusy }]">
        <div
          class="flex flex-col md:flex-row md:justify-between md:items-center gap-[10px] md:gap-0 mb-2"
        >
          <div class="flex flex-col gap-[16px]">
            <button
              class="text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px] border-b-2 border-[#2463EB] text-[#2463EB] max-w-max"
            >
              Stocks Transfer
            </button>
            <p class="text-[#353535] text-[14px] leading-[20px] font-semibold">
              List of all stocks transfer created/on the system
            </p>
          </div>
          <div class="flex gap-[10px] items-center">
            <button
              @click="viewFilter"
              class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
            >
              <span class="">
                <img src="/assets/icon/sort.svg" alt="" />
              </span>
              Filters
            </button>
            <button
              class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none max-w-max w-full"
              @click="viewAdd"
              v-if="hasPermission('Stock_Transfer_Create')"
            >
              <i class="feather icon-plus"></i> &nbsp;New Stock Transfer
            </button>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table dataTable text-nowrap min-h-[150px]">
            <thead class="bg-white">
              <tr>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Transfer ID
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Originating Warehouse / Storage Area
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Total Items
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Total Stock Value
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Status
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr v-if="loading">
                <td colspan="12" class="text-center">
                  <div
                    class="text-center"
                    style="padding-top: 100px; padding-bottom: 50px"
                  >
                    <span
                      class="fa-solid fa-spinner fa-spin text-[#2463EB]"
                      style="font-size: 8rem"
                    ></span>
                    <h3
                      class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                      style="padding-bottom: 100px"
                    >
                      Please wait while we load the list
                    </h3>
                  </div>
                </td>
              </tr>
              <tr v-for="l in StockTransfers" :key="l.id" v-else>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ l.referenceId || "N/A" }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ l.origin.location.name }}, {{ l.origin.name }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ l.quantityTransfered }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  &#8358;{{ formatMoney(l.totalStock) }}
                </td>
                <td>
                  <span
                    class="flex items-center gap-[4px] max-w-max w-full"
                    :class="[
                      'badge',
                      {
                        'badge-success': l.status == 'ACTIVE',
                        'badge-danger': l.status == 'REVERSED',
                      },
                    ]"
                  >
                    <span
                      class="w-[10px] h-[10px] rounded-[1px]"
                      :style="{
                        backgroundColor:
                          l.status == 'ACTIVE' ? '#16a249' : '#EF5253',
                      }"
                    ></span>
                    <span class="text-[12px] font-normal leading-[16.94px]">{{
                      l.status == "ACTIVE" ? "Completed" : "Reversed"
                    }}</span>
                  </span>
                </td>
                <td>
                  <button
                    class="btn-no-border"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span
                      class="text-[#98a2b3] dropdown text-2xl cursor-pointer relative outline-none active:outline-none shadow-none"
                    >
                      ...
                    </span>
                  </button>
                  <ul
                    class="dropdown-menu shadow-none"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <li
                      :class="[
                        'text-[14px] font-normal leading-[14px] text-[#353535] cursor-pointer py-[10px] px-[16px]',
                        hasPermission('Stock_Transfer_Update') &&
                        l.status != 'REVERSED'
                          ? 'border-b'
                          : '',
                      ]"
                      @click.prevent="viewDetails(l.id)"
                    >
                      View Details
                    </li>
                    <li
                      v-if="
                        hasPermission('Stock_Transfer_Update') &&
                          l.status != 'REVERSED'
                      "
                      :class="[
                        'text-[14px] text-[#DC2828] font-normal leading-[14px] text-[#353535] cursor-pointer py-[10px] px-[16px]',
                      ]"
                      @click.prevent="confirmReverse(l.id)"
                    >
                      Reverse
                    </li>
                  </ul>
                </td>
              </tr>
              <tr v-if="!StockTransfers.length && !loading">
                <td colspan="12">
                  <div class="text-center" style="padding-top: 50px">
                    <span
                      style="font-size: 4.615rem"
                      class="mdi mdi-crosshairs-gps"
                    ></span>
                  </div>
                  <h3 class="text-center" style="padding-bottom: 100px">
                    You don't have any stock transfers.
                  </h3>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination
            :limit="pageSize"
            :count="pageCount"
            :page="page"
            :itemsCount="count"
            @changePage="gotoPage"
            @changeLimit="changeLimit"
          />
        </div>
      </div>
    </div>

    <div class="modal fade" id="mod-add" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] min-h-screen"
        >
          <div class="modal-header- flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
            >
              Create New Stock Transfer
            </h4>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Transfer from</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="createStockTransfer.locationId"
                  data-live-search="true"
                  @input="getSubLocations($event)"
                >
                  <option value="null" selected disabled
                    >Select storage area</option
                  >
                  <option
                    v-for="loc in Locations"
                    :key="loc.id"
                    :value="loc.id"
                  >
                    {{ loc.name }}
                  </option>
                </select>

                <ul v-if="v1.locationId" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Select storage area</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  :disabled="!createStockTransfer.locationId || isLocationBusy"
                  v-model="createStockTransfer.subLocationId"
                  data-live-search="true"
                >
                  <option value="null" selected disabled
                    >Select storage area</option
                  >
                  <option
                    v-for="loc in SubLocations"
                    :key="loc.id"
                    :value="loc.id"
                  >
                    {{ loc.name }}
                  </option>
                </select>

                <ul v-if="v1.subLocationId" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full mt-[24px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click.prevent="create"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Done</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="mod-confirm" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div
            class="modal-header modal-header-colored  flex items-start justify-between p-0 m-0"
          >
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
            >
              Confirm Reverse
            </h4>
            <button
              class="text-2xl text-[#353535] border-solid border-[#353535] border-[1.5px] rounded-full px-[4px]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body p-0 m-0">
            <p class="text-[#96a0b5] text[14px] font-normal leading-[20px]">
              Are you sure you want to reverse this transaction
            </p>
            <div class="mt-[16px] flex items-center gap-[8px]">
              <button
                class="border-[#96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
                type="button"
                @click.prevent="cancelConfirm"
              >
                Cancel
              </button>
              <button
                :disabled="isBusyModal"
                class="bg-[#DC2828] border-[#DC2828] text-white border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
                type="button"
                @click.prevent="reverseTransfer"
              >
                <span v-if="isBusyModal">Busy...</span>
                <span v-else>Confirm</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="mod-filter" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] min-h-screen"
        >
          <div class="modal-header- flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
            >
              Filter
            </h4>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Warehouse</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="filter.locationId"
                >
                  <option value="0">All Warehouses</option>
                  <option
                    v-for="loc in Locations"
                    :key="loc.id"
                    :value="loc.id"
                  >
                    {{ loc.name }}
                  </option>
                </select>
              </div>
            </div>

            <div>
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Other filters</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Filter by product code or product name..."
                  v-model="filter.qry"
                />
              </div>
            </div>

            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
              ></label>
              <div>
                <label
                  class="custom-control custom-checkbox custom-control-inline"
                >
                  <input
                    class="custom-control-input"
                    type="checkbox"
                    v-model="filter.showForMe"
                  />
                  <span class="custom-control-label">My Inventories Only</span>
                </label>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full mt-[32px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click="reset"
            >
              Reset
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click="getTransfers"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
    <viewStockDetails
      :closeModal="closeModal"
      v-if="isModalVisible"
      :stockId="stockId"
      :transferDetails="transferDetails"
      :isBusy="isBusy"
    />
    <newStockTransfer
      :close="close"
      v-if="isNewModalVisible"
      :createLocationId="createStockTransfer.subLocationId"
    />
  </div>
</template>

<script>
/* eslint-disable */

import moment from "moment";
import { helper } from "@/helper";
import Select2 from "@/components/Select2";
import SystemPermissions from "@/permissions";
import Pagination from "../components/Pagination.vue";
import viewStockDetails from "../components/Inventory/viewStockDetails.vue";
import newStockTransfer from "../components/Inventory/newStockTransfer.vue";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "settingsStockTransfer",
  components: {
    Select2,
    Pagination,
    viewStockDetails,
    newStockTransfer,
  },

  created() {
    if (!this.hasPermission("Stock_Transfer_View")) {
      this.$router.push("/restricted");
    }
    if (this.hasPermission("Global_View_Stock_Transfer")) {
      this.isGlobal = true;
    } else {
      this.isGlobal = false;
    }
    this.getLocations();
    this.getTransfers();
  },

  data() {
    return {
      filter: {
        status: "0",
        locationId: "0",
        qry: "",
        showForMe: false,
      },
      isBusy: false,
      loading: false,
      isBusyModal: false,
      isLocationBusy: false,
      isGlobal: false,
      createStockTransfer: {
        locationId: null,
        subLocationId: null,
      },
      v1: {
        locationId: null,
        subLocationId: null,
      },
      StockTransfers: [],
      Locations: [],
      SubLocations: [],
      ProductId: "",
      Products: [],
      count: 0,
      page: 1,
      pageSize: 10,
      pageCount: 0,
      hasNext: false,
      hasPrev: false,
      isModalVisible: false,
      stockId: "",
      transferDetails: [],
      isNewModalVisible: false,
      createLocationId: "",
    };
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },
  methods: {
    async create() {
      this.isBusyModal = true;
      this.isBusy = true;

      if (this.validateCreate()) {
        $("#mod-add").modal("hide");
        this.isNewModalVisible = true;
      }
      this.isBusy = false;
      this.isBusyModal = false;
    },
    closeModal() {
      this.isModalVisible = false;
      document.body.style.overflow = "auto";
      this.getTransfers();
    },
    async viewDetails(id) {
      this.isBusy = true;
      this.isBusyModal = true;
      let transferId = id;
      try {
        const res = await this.$http.get(
          `/Inventories/stockTransfer/${transferId}`
        );
        const reducer = (a, b) => a + b;
        const val = res.body.products
          .map((el) => +el.product.retailPrice * +el.quantityTransfered)
          .reduce(reducer, 0);
        this.transferDetails = res.body;
        this.transferDetails.stockValue = val;
      } catch (error) {
      } finally {
        this.isBusyModal = false;
        this.isBusy = false;
        this.isModalVisible = true;
        document.body.style.overflow = "hidden";
      }
    },
    reset() {
      this.page = 1;
      this.filter = {
        locationId: "0",
        qry: "",
        showForMe: false,
      };
    },

    cancel() {
      $("#mod-edit").modal("hide");
    },

    viewAdd() {
      this.createStockTransfer = {
        locationId: null,
        subLocationId: null,
      };
      this.v1 = {
        locationId: null,
        subLocationId: null,
      };
      $("#mod-add").modal("show");
    },
    viewFilter() {
      this.page = 0;
      $("#mod-filter").modal("show");
    },

    confirmReverse(id) {
      this.ProductId = id;
      $("#mod-confirm").modal("show");
    },

    cancelConfirm() {
      this.ProductId = "";
      $("#mod-confirm").modal("hide");
    },

    viewGlobal() {
      $("#mod-global").modal("show");
    },

    async reverseTransfer() {
      this.isBusyModal = true;
      try {
        const res = await this.$http.put(
          `/Inventories/stockTransfer/reverse/${this.ProductId}`
        );
        if (res.ok) {
          this.$toast.success("Stock transfer reversed successfully", {
            icon: true,
            rtl: false,
          });
          this.getTransfers();
          this.cancelConfirm();
        }
      } catch (error) {}
      this.isBusyModal = false;
    },

    validateCreate() {
      this.v1 = {
        locationId: null,
        subLocationId: null,
      };
      var isValid = true;

      if (!this.createStockTransfer.locationId) {
        this.v1.locationId = true;
        isValid = false;
      }

      if (!this.createStockTransfer.subLocationId) {
        this.v1.subLocationId = true;
        isValid = false;
      }

      return isValid;
    },
    close() {
      this.isNewModalVisible = false;
      document.body.style.overflow = "auto";
      this.getTransfers();
    },
    async getTransfers() {
      this.isBusy = true;
      this.loading = true;
      if (this.filter.qry) {
        this.page = 1;
      }
      try {
        const res = await this.$http.get(
          "/Inventories/stockTransfer?pageNumber=" +
            (this.page - 1) +
            "&pageSize=" +
            this.pageSize +
            (this.filter.locationId != "0"
              ? "&locationId=" + this.filter.locationId
              : "") +
            (this.filter.qry != "" ? "&query=" + this.filter.qry : "") +
            (this.user.parentId ? "&parentId=" + this.user.parentId : "") +
            (this.filter.showForMe != ""
              ? "&showForMe=" + this.filter.showForMe
              : "") +
            "&showForMe=" +
            !this.isGlobal
        );
        if (res.ok) {
          const updatedTransfers = res.body.data.map((el) => {
            const totalStock = el.products
              .map(
                (prod) => +prod.product.retailPrice * +prod.quantityTransfered
              )
              .reduce((a, b) => a + b, 0);

            return { ...el, totalStock };
          });
          this.StockTransfers = updatedTransfers;
          this.page = res.body.pageNumber + 1;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize);
          this.hasPrev = res.body.hasPrev;
          this.hasNext = res.body.hasNext;
          this.isBusy = false;
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
      }
    },

    getLocations() {
      var t = "Location";
      var a = true;

      this.$http
        .get(
          "/Locations/getListNoPaging?active=" +
            a +
            "&parentId=" +
            this.user.parentId
        )
        .then(function(res) {
          this.Locations = res.body;
        })
        .catch(function() {});
    },
    getSubLocations(e) {
      this.isLocationBusy = true;
      var t = "Location";
      var a = true;

      this.$http
        .get(
          "/SubLocations/getListNoPaging?active=" +
            a +
            "&parentId=" +
            this.user.parentId +
            "&locationId=" +
            e.target.value
        )
        .then(function(res) {
          this.SubLocations = res.body;
        })
        .catch(function() {});
      this.isLocationBusy = false;
    },
    getProducts() {
      var a = true;

      this.$http
        .get(
          "/Products/getListNoPagingForDistributor?active=" +
            a +
            "&parentId=" +
            this.user.parentId
        )
        .then(function(res) {
          this.Products = res.body;
        })
        .catch(function() {});
    },

    formatDate(date) {
      return moment(date).format("ll");
    },
    formatDateWithTime(date) {
      return moment(date).format("lll");
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
    formatNumber(val) {
      return helper.formatNumber(val);
    },
    prev() {
      this.page -= 1;
      this.getTransfers();
    },
    next() {
      this.page += 1;
      this.getTransfers();
    },

    gotoPage(page) {
      this.page = page;
      this.getTransfers();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.getTransfers();
    },
  },
};
</script>
